/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Heading_2Inputs */

const en_common_editor_heading_2 = /** @type {(inputs: Common_Editor_Heading_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heading 2`)
};

const zh_common_editor_heading_2 = /** @type {(inputs: Common_Editor_Heading_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二级标题`)
};

/**
* | output |
* | --- |
* | "Heading 2" |
*
* @param {Common_Editor_Heading_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_heading_2 = /** @type {((inputs?: Common_Editor_Heading_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Heading_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_heading_2(inputs)
	return zh_common_editor_heading_2(inputs)
});
export { common_editor_heading_2 as "common.editor.heading_2" }